import ru from "@rmp/core/plugins/i18n/locales/ru";

export default {
	ru
};
